import {
	Dialog2faSettings,
	DialogAccessCredentialsContainer,
	DialogActivityLog,
	DialogAddBeneficiary,
	DialogAlert,
	DialogAnalytics,
	DialogAssetGroup,
	DialogAutomaticSettlement,
	DialogBvnValidation,
	DialogContactSupport,
	DialogCryptoSettings,
	DialogCurrencyConverter,
	DialogDeleteBeneficiary,
	DialogDeleteDeveloperIpAddress,
	DialogDeleteWalletAddress,
	DialogEditWalletAddressName,
	DialogExpandedJsonViewer,
	DialogFileExport,
	DialogFilePreview,
	DialogFullScreenNotification,
	DialogFundRequest,
	DialogHelpArticle,
	DialogInactivityAlert,
	DialogLoading,
	DialogLogOut,
	DialogManageAutoSettlementAccount,
	DialogNotifications,
	DialogOnboardingTodoList,
	DialogQrCode,
	DialogRateCalculator,
	DialogRatings,
	DialogRemoveTeamMember,
	DialogResendWebhook,
	DialogResolveTrade,
	DialogRewardPoints,
	DialogSetDeveloperIpAddresses,
	DialogSettlementWallet,
	DialogSwitchUserAccount,
	DialogSwitchUserAccountMobile,
	DialogTooltip,
	DialogTopup,
	DialogTransactionDetails,
	DialogTwoFaSecurityPolicy,
	DialogTwoFaWarning,
	DialogVerifyTransaction,
	DialogWebhookVerification,
	DialogWithdrawalHistoryDetails,
	DialogWithdrawRequest,
} from 'BreetComponents';
import type { ReactNode } from 'react';

import RequestNewPassword from '@/app/(nonprotected)/(auth)/reset-password/new-password/modal/RequestNewPassword';
import { DialogInviteTeamMember } from '@/components/DialogInviteTeamMember';

export const modalConfig = {
	initial: 'initialModal',
	inactivity: 'inactivity',
	testModal: 'test_modal',
	addbeneficiary: 'addbeneficiary',
	convertCurrency: 'convertCurrency',
	rateCalculator: 'rateCalculator',
	cryptoSettings: 'cryptoSettings',
	settlementWallet: 'settlementWallet',
	fileExport: 'fileExport',
	twoFASecurityPolicy: 'twoFASecurityPolicy',
	assetGroup: 'assetGroup',
	verifyTransaction: 'verifyTransaction',
	fullScreenNotification: 'fullScreenNotification',
	withdrawFunds: 'withdrawFunds',
	fundWallet: 'fundWallet',
	topup: 'topup',
	activityLog: 'activityLog',
	analyticsModal: 'analyticsModal',
	onBoardingTodoList: 'onBoardingTodoList',
	switchUserAccount: 'switchUserAccount',
	switchUserAccountMobile: 'switchUserAccountMobile',
	qrCode: 'qrCode',
	inviteTeamMember: 'inviteTeamMember',
	deleteTeamMember: 'deleteTeamMember',
	deletebeneficiary: 'deletebeneficiary',
	deleteWalletAddress: 'deleteWalletAddress',
	previewKYBFile: 'previewKYBFile',
	loadingDialog: 'loadingDialog',
	jsonViewer: 'jsonViewer',
	tooltip: 'tooltip',
	notifications: 'notifications',
	twoFAWarning: 'twoFAWarning',
	requestNewPassword: 'requestNewPassword',
	autoSettlement: 'autoSettlement',
	bvnValidation: 'bvnValidation',
	editDeveloperIpAddress: 'editDeveloperIpAddress',
	manageAutoSettlement: 'manageAutoSettlement',
	twoFaSettings: 'twoFaSettings',
	requestPayment: 'requestPayment',
	resendWebhook: 'resendWebhook',
	accessCredentials: 'accessCredentials',
	webhookVerification: 'webhookVerification',
	editWalletAddressName: 'editWalletAddressName',
	deleteIpAddress: 'deleteIpAddress',
	alert: 'alert',
	contactSupport: 'contactSupport',
	resolveTrade: 'resolveTrade',
	transactionDetails: 'transactionDetails',
	withdrawalHistoryDetails: 'withdrawalHistoryDetails',
	rewardPoints: 'rewardPoints',
	ratings: 'ratings',
	logout: 'logout',
	helpArticle: 'helpArticle',
} as const;

export type ModalConfigKeyType = keyof typeof modalConfig;
export type ModalConfigType = typeof modalConfig;
export type ModalConfigIdType = ModalConfigType[ModalConfigKeyType];
export type ModalConfigVariant = 'right-sheet' | 'default';
export interface ModalConfigStateType {
	id: ModalConfigIdType;
	header?: string;
	wrapperClassName?: string;
	metadata?: unknown;
	dialogMessage?: string;
	variant?: ModalConfigVariant;
	hideCloseButton?: boolean;
	fullScreen?: boolean;
}

export const manuallyTriggeredModals: ModalConfigIdType[] = ['test_modal'];

export const modalContent: Record<ModalConfigIdType, ReactNode> = {
	initialModal: null,
	addbeneficiary: <DialogAddBeneficiary />,
	accessCredentials: <DialogAccessCredentialsContainer />,
	alert: <DialogAlert />,
	contactSupport: <DialogContactSupport />,
	assetGroup: <DialogAssetGroup />,
	fileExport: <DialogFileExport />,
	tooltip: <DialogTooltip />,
	analyticsModal: <DialogAnalytics />,
	activityLog: <DialogActivityLog />,
	convertCurrency: <DialogCurrencyConverter />,
	autoSettlement: <DialogAutomaticSettlement />,
	cryptoSettings: <DialogCryptoSettings />,
	settlementWallet: <DialogSettlementWallet />,
	deletebeneficiary: <DialogDeleteBeneficiary />,
	deleteWalletAddress: <DialogDeleteWalletAddress />,
	rateCalculator: <DialogRateCalculator />,
	switchUserAccount: <DialogSwitchUserAccount />,
	topup: <DialogTopup />,
	switchUserAccountMobile: <DialogSwitchUserAccountMobile />,
	twoFaSettings: <Dialog2faSettings />,
	inactivity: <DialogInactivityAlert />,
	loadingDialog: <DialogLoading />,
	deleteTeamMember: <DialogRemoveTeamMember />,
	bvnValidation: <DialogBvnValidation />,
	inviteTeamMember: <DialogInviteTeamMember />,
	onBoardingTodoList: <DialogOnboardingTodoList />,
	fullScreenNotification: <DialogFullScreenNotification />,
	twoFASecurityPolicy: <DialogTwoFaSecurityPolicy />,
	logout: <DialogLogOut />,
	twoFAWarning: <DialogTwoFaWarning />,
	qrCode: <DialogQrCode />,
	manageAutoSettlement: <DialogManageAutoSettlementAccount />,
	notifications: <DialogNotifications />,
	previewKYBFile: <DialogFilePreview />,
	jsonViewer: <DialogExpandedJsonViewer />,
	verifyTransaction: <DialogVerifyTransaction />,
	ratings: <DialogRatings />,
	editWalletAddressName: <DialogEditWalletAddressName />,
	requestNewPassword: <RequestNewPassword />,
	requestPayment: <DialogWithdrawRequest />,
	withdrawFunds: <></>,
	fundWallet: <DialogFundRequest />,
	resolveTrade: <DialogResolveTrade />,
	rewardPoints: <DialogRewardPoints />,
	resendWebhook: <DialogResendWebhook />,
	test_modal: null,
	transactionDetails: <DialogTransactionDetails />,
	withdrawalHistoryDetails: <DialogWithdrawalHistoryDetails />,
	webhookVerification: <DialogWebhookVerification />,
	deleteIpAddress: <DialogDeleteDeveloperIpAddress />,
	editDeveloperIpAddress: <DialogSetDeveloperIpAddresses />,
	helpArticle: <DialogHelpArticle />,
};

export const closeModalById = (modalId: ModalConfigIdType) => {
	const modalCloseBtn = document.getElementById(`closeBtnRef-${modalId}`) as HTMLButtonElement | null;
	if (!modalCloseBtn) return;
	modalCloseBtn.click();
};

export const modalMaxWidthConfig: Partial<Record<ModalConfigIdType, string>> = {
	requestNewPassword: '42.9rem',
	accessCredentials: '42.9rem',
	autoSettlement: '40.9rem',
	cryptoSettings: '46.4rem',
	settlementWallet: '34.2rem',
	deletebeneficiary: '40.9rem',
	deleteIpAddress: '40.9rem',
	fullScreenNotification: '50rem',
	activityLog: '40.9rem',
	twoFAWarning: '36.2rem',
	twoFASecurityPolicy: '35.5rem',
	analyticsModal: '82.9rem',
	resendWebhook: '34.2rem',
	deleteWalletAddress: '40.9rem',
	loadingDialog: '16rem',
	qrCode: '25rem',
	topup: '34.2rem',
	editDeveloperIpAddress: '40.9rem',
	tooltip: '27.5rem',
	editWalletAddressName: '40.9rem',
	onBoardingTodoList: '61.3rem',
	deleteTeamMember: '36.7rem',
	rewardPoints: '40.9rem',
	assetGroup: '40.9rem',
	resolveTrade: '46.4rem',
	bvnValidation: '34.2rem',
	switchUserAccount: '46rem',
	switchUserAccountMobile: '46rem',
	ratings: '36.5rem',
	alert: '40rem',
	contactSupport: '40rem',
	logout: '40rem',
	inactivity: '40rem',
	webhookVerification: '35.7rem',
	helpArticle: '64rem',
};

export const modalMaxHeightConfig: Partial<Record<ModalConfigIdType, string>> = {
	autoSettlement: '89svh',
	assetGroup: '89svh',
	helpArticle: '90svh',
};
